:global {
  @keyframes border-spin {
    0% {
      transform: rotate(0);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}

.root {
  border: 3px solid var(--color-bright-green);
  border-right-color: transparent;
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  animation: border-spin 0.75s linear infinite;
}
